/* eslint-disable */

// https://www.reddit.com/r/learnjavascript/comments/3coq4g/how_does_concatapply_work/
// flattens array when concat
export function concat(...args) {
    return Array.prototype.concat.apply([], args);
}

export function arrayIntersection(arr1, arr2) {
    return [...arr1].filter(key => arr2.includes(key));
}

export function arrayDifference(arr1, arr2) {
    return [...arr1].filter(key => !arr2.includes(key));
}

// runs an array through a series of filter functions, until results are found
// if no results are found - an empty array is returned
export function multiFilter(array, filterFunctions) {
    let arrayNew = [];
    let i = 0;

    while (!arrayNew.length && filterFunctions[i]) {
        arrayNew = array.filter(filterFunctions[i]);
        i++;
    }

    return arrayNew;
}
